import React from "react";
import {FaClipboardCheck} from "react-icons/fa";
import {FaLocationPin} from "react-icons/fa6";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import CheckHasData from "../check-has-data.jsx";

const Sos = ({data, selected}) => {
    const navigate = navigateHook();
    const {toggleItemsNode} = useEdgeBuilder();

    const open = () => {
        const urlDev = `/sos/citizens/form/${data.id}`
        
        navigate(urlDev, true);
    }

    const icon = (
        <img
            className="m-auto w-[20px]"
            src={getAssetPath("img/dashboard-svg/sw.sos.svg")}
            alt="image"
        />
    );

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            {
                toggleItemsNode.sos.status &&
                <div className={"flex items-center"}>
                    <FaClipboardCheck/>
                    <p className={"ml-1 mb-0"}>
                        <CheckHasData value={data.status} />
                    </p>
                </div>
            }
            {
                toggleItemsNode.sos.address &&
                <div className={"flex items-center"}>
                    <FaLocationPin/>
                    <p className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                        <CheckHasData value={data.address} />
                    </p>
                </div>
            }
        </div>
    )

    const title = (
        <>
            <p className={"overflow-hidden whitespace-nowrap text-ellipsis"}><b>{data.protections.map(p => p).join(", ")}</b></p>
        </>
    )

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={null}
            infoBlock={infoBlock}
            onSearchConnections={() => {
            }}
            onExtraAction={open}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#ffb947]"}
            bgBody={"bg-[#fffcef]"}
        />
    );
};

export default Sos;
